import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { ROUTE_BASE_URL, baseUrl } from "../../api/common"
import { showToast, ToastMessage } from "../Shared/ToastMessage"
import axios from "axios"
import Loader from "../common/Loader"
import { useUser } from "./UserContext"
import { FaUser, FaEnvelope, FaLock, FaEdit, FaHome, FaChevronRight, FaEye, FaEyeSlash } from "react-icons/fa"

const MyProfile = () => {
  const { updateUser, adminProfile, websiteName } = useUser()

  const [image, setImage] = useState("../../assets/images/sm/avatar1.jpg")
  const fileInputRef = useRef(null)

  const handleImageClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (file) {
      const imageUrl = URL.createObjectURL(file)
      setImage(imageUrl)
      formValues.profile = file
    }
  }

  const [formValues, setFormValues] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
    password: "",
  })

  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    email_id: "",
  })

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value })
  }

  const validate = () => {
    const newErrors = {
      first_name: "",
      last_name: "",
      email_id: "",
    }
    if (!formValues.first_name.trim()) {
      newErrors.first_name = "First name cannot be empty"
    }
    if (!formValues.last_name.trim()) {
      newErrors.last_name = "Last name cannot be empty"
    }
    if (!formValues.email_id.trim()) {
      newErrors.email_id = "Email cannot be empty"
    } else if (!/^\S+@\S+\.\S+$/.test(formValues.email_id.trim())) {
      newErrors.email_id = "Invalid email format"
    }
    setErrors(newErrors)
    return Object.values(newErrors).every((error) => error === "")
  }

  const clearInputValues = () => {
    setErrors({
      first_name: "",
      last_name: "",
      email_id: "",
    })
    setFormValues({
      first_name: "",
      last_name: "",
      email_id: "",
      password: "",
    })
  }

  const [myProfileDetails, setMyProfileDetails] = useState({})

  const fetchMyProfileData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/getProfile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })

      if (response.data.success) {
        const details = response.data.data
        setMyProfileDetails(details)
        setFormValues({
          first_name: details.first_name,
          last_name: details.last_name,
          email_id: details.email_id,
          password: details.password,
        })
        localStorage.setItem("loginUserName", `${details.first_name} ${details.last_name}`)
      } else {
        console.error("Error: Failed to fetch user data")
      }
    } catch (error) {
      console.error("Error fetching users data:", error)
    }
  }

  const updateProfile = async () => {
    if (validate()) {
      try {
        const response = await axios.post(`${baseUrl}/updateProfile`, formValues, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        if (response.data.success) {
          showToast(response.data.message, "success")
          fetchMyProfileData()
          clearInputValues()
        } else {
          showToast(response.data.message, "error")
        }
      } catch (error) {
        console.error("Error during submission:", error)
        showToast("Submission failed. Please try again.", "error")
      }
    }
  }

  const [showPassword, setShowPassword] = useState(false)
  const [isOtpModelOpen, setOtpModalOpen] = useState(false)
  const [otp, setOtp] = useState({
    digit1: "",
    digit2: "",
    digit3: "",
    digit4: "",
  })

  const handleSendOTP = async () => {
    handleOpenOTPModel()
    try {
      const response = await axios.post(
        `${baseUrl}/api/admin_send_otp`,
        {
          email: formValues.email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        },
      )

      if (response.data.status) {
        handleOpenOTPModel()
      } else {
        console.error("Error: Failed to fetch user data")
      }
    } catch (error) {
      console.error("Error fetching users data:", error)
    }
  }

  const handleResendOTP = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/admin_resend_otp`,
        {
          id: localStorage.getItem("loginUserId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        },
      )
      if (response.data.status) {
        showToast(response.data.message, "success")
      } else {
        showToast(response.data.message, "error")
      }
    } catch (error) {
      console.error("Error fetching users data:", error)
    }
  }

  const hanldeOTPVerify = async () => {
    const combinedOtp = otp.digit1 + otp.digit2 + otp.digit3 + otp.digit4
    try {
      const response = await axios.post(
        `${baseUrl}/api/admin_otp_verify`,
        {
          id: localStorage.getItem("loginUserId"),
          otp: combinedOtp,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        },
      )
      if (response.data.status) {
        showToast(response.data.message, "success")
        handleOpenChangePasswordModal()
      } else {
        showToast(response.data.message, "error")
      }
    } catch (error) {
      console.error("Error fetching users data:", error)
    }
  }

  const isOtpComplete = otp.digit1 && otp.digit2 && otp.digit3 && otp.digit4

  const handleOpenOTPModel = () => {
    setOtpModalOpen(true)
  }

  const handleCloseOTPModel = () => {
    setOtp({
      digit1: "",
      digit2: "",
      digit3: "",
      digit4: "",
    })
    setOtpModalOpen(false)
  }

  const handleOtpChange = (e, digit) => {
    const { value } = e.target
    if (value.length <= 1 && /^[0-9]*$/.test(value)) {
      setOtp({
        ...otp,
        [digit]: value,
      })
      const nextDigit = `digit${Number.parseInt(digit.charAt(5)) + 1}`
      if (value && digit !== "digit4") {
        document.getElementById(nextDigit).focus()
      }
    }
  }

  const [changePasswordFormValues, setChangePasswordFormValues] = useState({
    password: "",
    confirm_password: "",
  })

  const [changePasswordErrors, setChangePasswordErrors] = useState({
    password: "",
    confirm_password: "",
  })

  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false)

  const handleChangePasswordInputChange = (field, value) => {
    setChangePasswordFormValues({ ...changePasswordFormValues, [field]: value })
  }

  const handleOpenChangePasswordModal = () => {
    setOpenChangePasswordModal(true)
  }

  const handleCloseChangePasswordModal = () => {
    setOpenChangePasswordModal(false)
    handleCloseOTPModel()
  }

  const changePasswordValidate = () => {
    const newErrors = {
      password: "",
      confirm_password: "",
    }
    if (!changePasswordFormValues.password.trim()) {
      newErrors.password = "New password cannot be empty"
    }
    if (!changePasswordFormValues.confirm_password.trim()) {
      newErrors.confirm_password = "Confirm password cannot be empty"
    }
    if (changePasswordFormValues.password !== changePasswordFormValues.confirm_password) {
      newErrors.confirm_password = "Passwords do not match"
    }
    setChangePasswordErrors(newErrors)
    return Object.values(newErrors).every((error) => error === "")
  }

  const clearChangePasswordInputValues = () => {
    setChangePasswordErrors({
      password: "",
      confirm_password: "",
    })
    setChangePasswordFormValues({
      password: "",
      confirm_password: "",
    })
    handleCloseChangePasswordModal()
  }

  const updatePassword = async () => {
    if (changePasswordValidate()) {
      try {
        const requestData = {
          id: localStorage.getItem("loginUserId"),
          password: changePasswordFormValues.password,
        }
        const response = await axios.post(`${baseUrl}/api/admin_change_password`, requestData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("access_token"),
          },
        })
        if (response.data.status) {
          showToast(response.data.message, "success")
          fetchMyProfileData()
          clearChangePasswordInputValues()
        } else {
          showToast(response.data.message, "error")
        }
      } catch (error) {
        console.error("Error during submission:", error)
        showToast("Submission failed. Please try again.", "error")
      }
    }
  }

  useEffect(() => {
    fetchMyProfileData()
  }, [])

  if (!myProfileDetails || Object.keys(myProfileDetails).length === 0) {
    return <Loader />
  }

  const profileCards = [
    {
      title: "Personal Info",
      icon: <FaUser size={24} />,
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      bgLight: "#f0f4ff",
    },
    {
      title: "Account Security",
      icon: <FaLock size={24} />,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      bgLight: "#fff0f5",
    },
  ]

  return (
    <>
      <ToastMessage />
      <div className="container-fluid" style={{ padding: "24px 15px" }}>
        <div style={{ marginBottom: "22px" }}>
          {/* <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "20px 24px",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
              border: "1px solid #e5e7eb",
            }}
          >
            <div className="row align-items-center">
              <div className="col-md-12">
                <h2
                  style={{
                    fontSize: "24px",
                    fontWeight: "600",
                    color: "#1f2937",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, rgba(81, 144, 211, 1) 0%, rgb(24, 71, 120) 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                    }}
                  >
                    <FaHome size={18} />
                  </div>
                  My Profile
                </h2>
                <nav aria-label="breadcrumb" style={{ marginTop: "8px" }}>
                  <ol
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      fontSize: "14px",
                    }}
                  >
                    <li>
                      <Link
                        to={`${ROUTE_BASE_URL}/`}
                        style={{
                          color: "#6b7280",
                          textDecoration: "none",
                          transition: "color 0.2s ease",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#184778")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
                      >
                        AMASI
                      </Link>
                    </li>
                    <li style={{ color: "#d1d5db" }}>
                      <FaChevronRight size={10} />
                    </li>
                    <li style={{ color: "#184778", fontWeight: "500" }}>My Profile</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div> */}


          <div className="brood_comes_div">
            <div className="row align-items-center">
              <div className="col-md-6 brood_comes_heading">
                <h2 className="mb-2">
                  <div className="brood_comes_part">

                    <FaHome />
                  </div>
                  My Profile
                </h2>
                <nav aria-label="breadcrumb ">
                  <ol
                    style={{
                      display: "flex",
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      fontSize: "0.875rem",
                      color: "#6b7280",
                    }}
                  >
                    <li className="breadcrumb-item link_brood_comes" style={{ cursor: "pointer" }}>
                      <Link
                        to={`${ROUTE_BASE_URL}/`}
                        style={{
                          color: "#6b7280",
                          textDecoration: "none",
                          transition: "color 0.2s ease",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "#184778")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "#6b7280")}
                      >
                        All Events
                      </Link>
                    </li>
                    <li style={{ color: "#d1d5db" }}>
                      <FaChevronRight size={10} />
                    </li>
                    <li>My Profile</li>
                  </ol>
                </nav>

              </div>
              <div className="col-md-6 text-end">
                 
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            background: "linear-gradient(135deg, rgba(81, 144, 211, 1) 0%, rgb(24, 71, 120) 100%)",
            borderRadius: "12px",
            padding: "32px 24px",
            boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
            marginBottom: "22px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "200px",
              height: "200px",
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "50%",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "-30px",
              left: "-30px",
              width: "150px",
              height: "150px",
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "50%",
            }}
          />
          <div style={{ position: "relative", zIndex: 2 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                }}
              >
                <FaUser size={36} style={{ color: "rgb(24, 71, 120)" }} />
              </div>
              <div>
                <h3
                  style={{
                    color: "white",
                    fontSize: "28px",
                    fontWeight: "700",
                    margin: 0,
                    marginBottom: "4px",
                    textTransform: "capitalize",
                  }}
                >
                  {`${myProfileDetails.first_name} ${myProfileDetails.last_name}`}
                </h3>
                <p
                  style={{
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: "16px",
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FaEnvelope size={14} />
                  {myProfileDetails.email_id}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            marginBottom: "22px",
          }}
        >
          {/* Card Header */}
          <div
            style={{
              padding: "20px 24px",
              borderBottom: "1px solid #e5e7eb",
              background: "linear-gradient(to right, #f9fafb, #ffffff)",
            }}
          >
            <h5
              style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "600",
                color: "#1f2937",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FaEdit style={{ color: "#184778" }} />
              Edit Profile Information
            </h5>
          </div>

          {/* Card Body */}
          <div style={{ padding: "24px" }}>
            <div className="row">
              {/* First Name */}
              <div className="col-lg-6 col-md-12 mb-4">
                <label
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#6b7280",
                    marginBottom: "8px",
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  First Name <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      border: errors.first_name ? "2px solid #dc3545" : "1px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      outline: "none",
                    }}
                    value={formValues.first_name}
                    onChange={(e) => handleInputChange("first_name", e.target.value)}
                    onFocus={(e) => {
                      if (!errors.first_name) {
                        e.target.style.borderColor = "#667eea"
                        e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)"
                      }
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb"
                      e.target.style.boxShadow = "none"
                    }}
                  />
                  {errors.first_name && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "12px",
                        marginTop: "4px",
                        marginBottom: 0,
                      }}
                    >
                      {errors.first_name}
                    </p>
                  )}
                </div>
              </div>

              {/* Last Name */}
              <div className="col-lg-6 col-md-12 mb-4">
                <label
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#6b7280",
                    marginBottom: "8px",
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Last Name <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      border: errors.last_name ? "2px solid #dc3545" : "1px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      outline: "none",
                    }}
                    value={formValues.last_name}
                    onChange={(e) => handleInputChange("last_name", e.target.value)}
                    onFocus={(e) => {
                      if (!errors.last_name) {
                        e.target.style.borderColor = "#667eea"
                        e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)"
                      }
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb"
                      e.target.style.boxShadow = "none"
                    }}
                  />
                  {errors.last_name && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "12px",
                        marginTop: "4px",
                        marginBottom: 0,
                      }}
                    >
                      {errors.last_name}
                    </p>
                  )}
                </div>
              </div>

              {/* Email */}
              <div className="col-lg-6 col-md-12 mb-4">
                <label
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#6b7280",
                    marginBottom: "8px",
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Email <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <div style={{ position: "relative" }}>
                  <input
                    type="email"
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      border: errors.email_id ? "2px solid #dc3545" : "1px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      outline: "none",
                    }}
                    value={formValues.email_id}
                    onChange={(e) => handleInputChange("email_id", e.target.value)}
                    onFocus={(e) => {
                      if (!errors.email_id) {
                        e.target.style.borderColor = "#667eea"
                        e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)"
                      }
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb"
                      e.target.style.boxShadow = "none"
                    }}
                  />
                  {errors.email_id && (
                    <p
                      style={{
                        color: "#dc3545",
                        fontSize: "12px",
                        marginTop: "4px",
                        marginBottom: 0,
                      }}
                    >
                      {errors.email_id}
                    </p>
                  )}
                </div>
              </div>

              {/* Password */}
              <div className="col-lg-6 col-md-12 mb-4">
                <label
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#6b7280",
                    marginBottom: "8px",
                    display: "block",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Password
                </label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <div style={{ position: "relative", flex: 1 }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      style={{
                        width: "100%",
                        padding: "12px 16px",
                        border: "1px solid #e5e7eb",
                        borderRadius: "8px",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        outline: "none",
                      }}
                      value={formValues.password}
                      onChange={(e) => handleInputChange("password", e.target.value)}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#667eea"
                        e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)"
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#e5e7eb"
                        e.target.style.boxShadow = "none"
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    style={{
                      padding: "12px 16px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      background: "white",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#f9fafb"
                      e.currentTarget.style.borderColor = "#667eea"
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "white"
                      e.currentTarget.style.borderColor = "#e5e7eb"
                    }}
                  >
                    {showPassword ? (
                      <FaEyeSlash style={{ color: "#6b7280" }} />
                    ) : (
                      <FaEye style={{ color: "#6b7280" }} />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
              <button
                type="button"
                className="btn btn-outline-primary "
              >
                Update Profile
              </button>
            </div>
          </div>
        </div>
      </div>

      {isOtpModelOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
          onClick={handleCloseOTPModel}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              maxWidth: "500px",
              width: "90%",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: "20px 24px",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>OTP Validation</h5>
              <button
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#6b7280",
                }}
                onClick={handleCloseOTPModel}
              >
                ×
              </button>
            </div>
            <div style={{ padding: "24px" }}>
              <p style={{ color: "#6b7280", marginBottom: "20px" }}>
                The OTP is being sent to your registered email id
              </p>
              <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginBottom: "24px" }}>
                {Object.keys(otp).map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    id={digit}
                    style={{
                      width: "60px",
                      height: "60px",
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "600",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                      outline: "none",
                      transition: "all 0.2s ease",
                    }}
                    value={otp[digit]}
                    onChange={(e) => handleOtpChange(e, digit)}
                    maxLength={1}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#667eea"
                      e.target.style.boxShadow = "0 0 0 3px rgba(102, 126, 234, 0.1)"
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb"
                      e.target.style.boxShadow = "none"
                    }}
                  />
                ))}
              </div>
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "white",
                    color: "#667eea",
                    border: "2px solid #667eea",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={handleResendOTP}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f0f4ff"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "white"
                  }}
                >
                  Resend OTP
                </button>
                <button
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: isOtpComplete ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" : "#e5e7eb",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: isOtpComplete ? "pointer" : "not-allowed",
                    transition: "all 0.2s ease",
                  }}
                  onClick={hanldeOTPVerify}
                  disabled={!isOtpComplete}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {openChangePasswordModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
          onClick={handleCloseChangePasswordModal}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              maxWidth: "500px",
              width: "90%",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: "20px 24px",
                borderBottom: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>Change Password</h5>
              <button
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "24px",
                  cursor: "pointer",
                  color: "#6b7280",
                }}
                onClick={handleCloseChangePasswordModal}
              >
                ×
              </button>
            </div>
            <div style={{ padding: "24px" }}>
              <p style={{ color: "#6b7280", marginBottom: "20px" }}>Would you like to change the Password?</p>
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#6b7280",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  Enter New Password
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: changePasswordErrors.password ? "2px solid #dc3545" : "1px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                  value={changePasswordFormValues.password}
                  onChange={(e) => handleChangePasswordInputChange("password", e.target.value)}
                />
                {changePasswordErrors.password && (
                  <p style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px" }}>
                    {changePasswordErrors.password}
                  </p>
                )}
              </div>
              <div style={{ marginBottom: "24px" }}>
                <label
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#6b7280",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  Enter Confirm Password
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: changePasswordErrors.confirm_password ? "2px solid #dc3545" : "1px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                  value={changePasswordFormValues.confirm_password}
                  onChange={(e) => handleChangePasswordInputChange("confirm_password", e.target.value)}
                />
                {changePasswordErrors.confirm_password && (
                  <p style={{ color: "#dc3545", fontSize: "12px", marginTop: "4px" }}>
                    {changePasswordErrors.confirm_password}
                  </p>
                )}
              </div>
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "white",
                    color: "#6b7280",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={handleCloseChangePasswordModal}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f9fafb"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "white"
                  }}
                >
                  Close
                </button>
                <button
                  style={{
                    flex: 1,
                    padding: "12px",
                    background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}
                  onClick={updatePassword}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)"
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(40, 167, 69, 0.3)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "none"
                  }}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MyProfile
